import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Pipe({
  name: 'getRoomRadiatorStatus'
})
export class GetRoomRadiatorStatusPipe implements PipeTransform {

  transform(controllers: Controller[], updated):
   'By presence' | 'By rented' | 'Force On' | 'Force Off' {

    const byRentedprops = [];
    const forcedOnProps = [];
    const forcedOffProps = [];

    controllers.forEach((cont)=> {
      cont.controllerProperties.$values.forEach((prop)=> {
        if (Property.isRadiatorByRented(prop)) {
          byRentedprops.push(prop)
        } else if (Property.isRadiatorForceOn(prop)) {
          forcedOnProps.push(prop)
        } else if (Property.isRadiatorForceOff(prop)) {
          forcedOffProps.push(prop)
        }
      })
    })

    if (forcedOnProps.some((p)=> Property.isActive(p))) {
      return 'Force On'
    } else if (forcedOffProps.some((p)=> Property.isActive(p))) {
      return 'Force Off'
    }else if (byRentedprops.some((p)=> Property.isActive(p))) {
      return 'By rented'
    } else {
      return 'By presence'
    }
  }

}
